<template>
  <div class="servedetailpage">
    <div class="serverdetailtop">
      <!--      <img class="serverdetailbanner" src="../../../static/test-bg1.jpg" /> -->
      <img class="serverdetailbanner" :src="showItem.thumb_url ? showItem.thumb_url : ''" />
      <div class="serverdetailname">{{ showItem.name }}</div>
      <!-- <div class="serverdetailnum">333已售</div> -->
      <div class="detailaddressbox">
        <div class="detailaddressleft">
          <img class="addressicon" src="../../../static/dizhi1.png" />
          <div class="addresstopbox">
            <div class="addresstext">{{ showItem.province + showItem.city + showItem.address }}</div>
            <!-- <div class="addressjulinum">距您当前0.11Km</div> -->
          </div>
        </div>
        <div class="detailrightbox">
          <div class="detaildaohangbox" @click="getMyLocation()"  id="container">
            <img class="daohangicon" src="../../../static/daohang.png" style="margin-bottom: 5px" />
            <div class="daohangtext">导航</div>
          </div>
          <div class="detailshu"></div>


          <div class="detaildaohangbox">
            <a :href="'tel:' + showItem.store_tel">
              <img class="daohangicon" src="../../../static/shangjia.png" />
              <div class="daohangtext">商家</div>
            </a>
          </div>

        </div>
      </div>
      <div class="detailyingye">
        <div class="detailyingyetype">
          <img class="detailyingyeicon" src="../../../static/qiri.png" />
          <div class="yingyetext">营业中</div>
        </div>
        <div class="detailshu"></div>
        <div class="yingyetext">{{ showItem.business_time }}</div>
      </div>
      <!-- <div class="detailclasslist">
        <div class="classbox">标准洗车</div>
        <div class="classbox">快速补胎</div>
      </div> -->
    </div>
    <div class="tabvaluebox">
      <van-tabs v-model="tabIndex" scrollspy sticky>
        <van-tab v-for="(item,index) in tablist" :title="item.text">
        </van-tab>
      </van-tabs>
    </div>
    <div class="detailbottom">
      <!-- <div class="detailtabbox">
        <div class="detailtabtext">服务项目</div>
      </div> -->
      <div class="shuomingtitle">服务项目</div>
      <div class="detailprobox">
        <div class="detailproductname">{{serviceList.name}}</div>
        <div class="detailproductpricebox">
          <div class="detailyuanprice">￥{{serviceList.m_price}}</div>
          <div class="detailxianprice">￥{{serviceList.price}}</div>
        </div>
      </div>
    </div>
    <!-- <div class="shuomingbox">
      <div class="shuomingtitle">服务说明</div>
      <div class="shuomingtext1">车表冲洗</div>
      <div class="shuomningdetail">冲洗车辆表面的灰尘、泥污、含轮胎和轮毂表面，<span style="color: #FF0000;">车外清洗不含树胶、沥青、和胶水印等特殊污渍</span></div>
    </div> -->
    <div class="shuomingbox">
      <div class="shuomingtitle">购买须知</div>
      <div class="shuomningdetail">1.有效期：具体服务券有效期请以提交订单页面提示为准；</div>
      <div class="shuomningdetail">3.适用车型：限7座（含7座）以下非营运车辆使用；</div>
      <div class="shuomningdetail">2.预约信息：无需预约，如遇消费高峰时段您可能需要排队；</div>
      <div class="shuomningdetail">4.规则提示：每张服务券最多1辆车使用；2天内最多可使用1张；需您当天一次性体验完毕所有项目</div>
    </div>

    <div class="shuomingbox">
      <div class="pingjiatop">
        <div class="pingjianame">车友评价（{{commentcount}})</div>
        <div class="pingjiamorebox" @click="toallEvaluate">
          <div class="pingjiamore">查看全部评价</div>
          <img class="pingjiaicon" src="../../../static/newicon/more.png" />
        </div>
      </div>
      <div class="pingjiabox" v-for="(item,index) in commentList">
        <div class="pingjiadetailtop">
          <div class="pingjiadetailleft">
            <img class="pingjiaimg" src="../../../static/morenimg.png" />
            <div>
              <div class="pingjiatel">{{item.is_anonymous==1 ? '匿名用户':  item.user.name }}</div>
              <div class="pingjiaxingbox">
                <ul class="star">
                  <li v-for="(itemClass,index) in item.starlist" :class="itemClass" class="star-item"></li>
                  <!--性能优化 track-by 数据不改变时不会重新渲染-->
                </ul>
              </div>
            </div>
          </div>
          <div class="pingjiatime">{{ item.created_at }}</div>
        </div>
        <div class="labellist">
          <div class="labelbox" v-for="(label,index) in item.tags">{{ label }}</div>
        </div>
        <div class="pingjiamessage">{{ item.content }}</div>
        <div class="pingjiaservebox">
          <div class="servenamepingjia">{{ item.source_data.product_name }}</div>
        </div>
      </div>
    </div>
    <div class="detailnone"></div>
    <div class="detailbuybox">
      <div class="detailbuyprice">￥{{serviceList.price}}</div>
      <div class="detailbuybottonbox" >
        <div class="detailbuybotton1"  v-if="serviceList.need_book==1" @click="toreservation">立即预约</div>
        <div class="detailbuybotton2" @click="toConfirm">立即购买</div>
      </div>
<!--      <div class="detailbuybotton" v-else @click="toConfirm">立即购买</div>-->
    </div>
  </div>
</template>

<script>
  import httper from "../../api/http";
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        store_id: "", //获取店铺编号,默认为空
        product_id: "", //卡券列表跳转过来的product_id
        package_id: "", //卡券id
        page: 1,
        page_size: 20,
        showItem: {},
        mobile: "",
        latitude: "",
        longitude: "",
        serviceid: "",
        serviceList: {},
        store_tel: "",
        tablist: [{
          text: "服务",
          value: 1
        }, {
          text: "说明",
          value: 2
        }, {
          text: "评价",
          value: 3
        }],
        tabValue: 1,
        tabIndex: 0,
        score: 3, //评分
        commentList: [],
        commentcount:0,
        scoresstar:[],
      }

    },
    computed: { //计算属性
      itemClasses() {
        let result = []; // 返回的是一个数组,用来遍历输出星星
        let score = Math.floor(this.score * 2) / 2; // 计算所有星星的数量
        let hasDecimal = score % 1 !== 0; // 非整数星星判断
        let integer = Math.floor(score); // 整数星星判断
        for (let i = 0; i < integer; i++) { // 整数星星使用on
          result.push("on"); // 一个整数星星就push一个CLS_ON到数组
        }
        if (hasDecimal) { // 非整数星星使用half
          result.push("half"); // 类似

        }
        while (result.length < 5) { // 余下的用无星星补全,使用off
          result.push("off");
        }
        return result;
      }
    },
    created() {
      if (this.$route.query.store_id) {
        this.store_id = this.$route.query.store_id
      } else if (this.$route.params.store_id) {
        this.store_id = this.$route.params.store_id
      } else {
        this.store_id = ""
      }
      if (this.$route.query.serviceid) {
        this.serviceid = this.$route.query.serviceid
      } else if (this.$route.params.serviceid) {
        this.serviceid = this.$route.params.serviceid
      } else {
        this.serviceid = ""
      }
      if (this.$route.query.product_id) {
        this.product_id = this.$route.query.product_id
      } else if (this.$route.params.product_id) {
        this.product_id = this.$route.params.product_id
      } else {
        this.product_id = ""
      }
      if (this.$route.params.package_id) {
        this.package_id = this.$route.params.package_id
      } else if (this.$route.query.package_id) {
        this.package_id = this.$route.query.package_id
      } else {
        this.package_id = ""
      }
      this.request("getUserInfo")
      let getstoredata = {
        id: this.store_id,
      }
      this.request("getStore", getstoredata);
      this.request("getStoreservice", {
        product_id: this.product_id,
        store_id: this.store_id
      })
      this.getwechat({
        url: location.href.split('#')[0]
      })
    },
    mounted() {
      console.log("itemClasses",this.itemClasses)
      // let requestData = {
      //   store_id: this.store_id,
      //   page: this.page,
      //   page_size: this.page_size,
      //   product_id: this.product_id
      // };

      // this.request("getService", requestData);
    },
    methods: {
      //评价星星
      itemClasses1() {
        let that = this
        let list = that.commentList
        // console.log("itemClasses1",list)
        for(let i in list){
          list[i].starlist = []
          // let result = []; // 返回的是一个数组,用来遍历输出星星
          let score = Math.floor(Number(list[i].star) * 2) / 2; // 计算所有星星的数量
          let hasDecimal = score % 1 !== 0; // 非整数星星判断
          let integer = Math.floor(score); // 整数星星判断
          for (let j = 0; j < integer; j++) { // 整数星星使用on
            list[i].starlist.push("on"); // 一个整数星星就push一个CLS_ON到数组
          }
          if (hasDecimal) { // 非整数星星使用half
            list[i].starlist.push("half"); // 类似

          }
          while (list[i].starlist.length < 5) { // 余下的用无星星补全,使用off
            list[i].starlist.push("off");
          }
        }
        that.commentList = list
      },

      //全部评价
      toallEvaluate() {
        this.$router.push({
          path: "/evaluateList",
          query:{
            entity_id: this.serviceList.id
          }
        })
      },
      //去预约
      toreservation() {
        this.$router.push({
          path: "/reservation",
          query: {
            store_id: this.store_id,
            product_id: this.product_id
          }
        })
        // this.$router.push({
        //   path: "/reservation"
        // })
      },
      //获取定位
      getMyLocation() {
        console.log("this.showItem",this.showItem)
        console.log("this.latitude",this.latitude)
        if (this.showItem && this.latitude) {
          // wx.ready(() => {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          wx.openLocation({
            latitude: Number(this.latitude), // 纬度，浮点数，范围为90 ~ -90
            longitude: Number(this.longitude), // 经度，浮点数，范围为180 ~ -180。
            name: this.showItem.name,
            address: this.showItem.address,
            scale: 16
          });
          // });
        }
      },
      toConfirm() {
        this.$router.push({
          path: "/orderConfirm",
          query: {
            store_id: this.store_id,
            product_id: this.product_id
          }
        })
      },
      // 跳转到套餐详情/预约页面
      toPackageDesc(type, id) {
        let that = this
        // 跳转到预约页面前，先判断是否有用户信息
        if ((!this.mobile)) {
          Dialog.confirm({
              title: '提示',
              message: '请先绑定手机',
            })
            .then(() => {
              that.$router.push({
                path: "/changePhoneNum"
              })
            })
            .catch(() => {
              return false;
            });
        } else {
          let serviceType = type;
          let serviceId = id;
          if (type == 1 || type == 2) {
            this.$router.push({
              path: "/packageDesc",
              query: {
                id: id
              }
            });
          } else {
            this.$router.push({
              path: "/reserveDesc",
              query: {
                id: id,
                package_id: this.package_id,
                store_id: this.store_id,
                product_id: this.product_id
              }
            });
          }
        }
      },

      //获取微信配置信息接口
      getwechat(requestData = {}) {
        httper.get("wechat/wechat/sign-package", requestData, res => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["openLocation"] // 必填，需要使用的JS接口列表
          });
        });
      },

      // 调用接口
      request(type = "", requestData = {}) {
        let that = this;
        let data = {};
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                that.userInfo = res.data
                that.mobile = res.data.mobile
              }
            }, true)
            break
            //获取微信配置
          case "getMyConfig":
            httper.get("wechat/wechat/sign-package", requestData, res => {
              wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.appId, // 必填，公众号的唯一标识
                timestamp: res.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.nonceStr, // 必填，生成签名的随机串
                signature: res.signature, // 必填，签名
                jsApiList: ["openLocation"] // 必填，需要使用的JS接口列表
              });
            });
            break;
            // 获取店铺详情
          case "getStore":
            httper.get("store/store-detail", requestData, res => {
              if (res.code == 0) {
                that.showItem = res.data;
                // console.log("that.showItem",that.showItem)
                // that.store_tel = res.data.store.store_tel
                that.latitude = res.data.latitude
                that.longitude = res.data.longitude
               // console.log("that.latitude",that.latitude)
                // this.request("getStoreservice", {
                //   id: this.serviceid
                // })
              } else {
                this.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, false);
            break;
            // 获取店铺服务详情
          case "getStoreservice":
            httper.post("store/ser-detail", requestData, res => {
              if (res.code == 0) {
                that.serviceList = res.data;
                that.showItem = res.data.store;
                that.latitude = res.data.store.latitude
                that.longitude = res.data.store.longitude
                this.request("getCommentList", {
                  page: 1,
                  page_size: 5,
                  entity: "store_service",
                  entity_id: that.serviceList.id,
                  star:5
                })
              } else {
                this.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true);
            break;
            // 获取评价列表
          case "getCommentList":
            httper.post("comment/list", requestData, res => {
              if (res.code == 0) {
                that.commentcount = res.data.count
                let list = res.data.list;
                // list.map(v => {
                //   that.$set(v, 'starlist', [])
                //   return v
                // })
                that.commentList = list;
                console.log("list",that.commentList)
                this.itemClasses1()

              } else {
                this.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true);
            break;
            // 店铺服务
          case "getService":
            httper.post("store/store-service-list", requestData, res => {
              if (!that.flag) return;
              that.page++;
              that.flag = res.data.length < that.page_size;
              for (let i in res.data) that.serviceList.push(res.data[i]);
            }, false);
            break;
        }
      },
    }
  }
</script>

<style>
  .servedetailpage {
    background-color: #F8F8FA;
  }

  .serverdetailtop {
    width: 100%;
    background-color: #FFFFFF;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .serverdetailbanner {
    width: 100%;
    border-radius: 8px;
    margin-bottom: 23px;
    height: 200px;
  }

  .serverdetailname {
    font-size: 19px;
    font-weight: bold;
    margin-bottom: 14px;
  }

  .serverdetailnum {
    font-size: 13px;
    margin-bottom: 30px;
  }

  .detailaddressbox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .detailaddressleft {
    width: 65%;
    display: flex;
  }

  .addressicon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }

  .addresstopbox {}

  .addresstext {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  .addressjulinum {
    font-size: 14px;
    color: #8484A0;
  }

  .detailrightbox {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .detaildaohangbox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .daohangicon {
    width: 25px;
    height: 25px;
    //margin-bottom: 5px;
  }

  .daohangtext {
    font-size: 15px;
    font-weight: 600;
    color: #FD8C00;
  }

  .detailshu {
    width: 1px;
    height: 12px;
    background-color: #EEEEEE;
    margin: 0 20px;
  }

  .detailyingye {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .detailyingyetype {
    display: flex;
    align-items: center;
  }

  .detailyingyeicon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }

  .yingyetext {
    font-size: 15px;
    font-weight: 600;
  }

  .detailclasslist {
    width: calc(100% - 40px);
    margin: 10px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .classbox {
    width: 69px;
    height: 23px;
    background: #F8F8FA;
    border-radius: 4px;
    margin: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #8484A0;
  }

  .detailbottom {
    width: 100%;
    background-color: #FFFFFF;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .detailtabbox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .detailtabtext {
    font-size: 15px;
    font-weight: 600;
  }

  .detailprobox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .detailproductname {
    font-size: 15px;
    font-weight: 600;
  }

  .detailproductpricebox {
    display: flex;
    align-items: center;
  }

  .detailyuanprice {
    font-size: 15px;
    color: #BBBBBB;
    margin-right: 18px;
    text-decoration: line-through;
  }

  .detailxianprice {
    font-size: 15px;
    color: #FF0000;
  }

  .shuomingbox {
    width: 100%;
    background-color: #FFFFFF;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .shuomingtitle {
    font-weight: 600;
    font-size: 17px;
    margin-bottom: 13px;
  }

  .shuomingtext1 {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .shuomningdetail {
    font-size: 15px;
    color: #666666;
    margin-bottom: 10px;
  }

  .detailbuybox {
    width: 100%;
    padding: 20px 20px 40px 20px;
    background-color: #FFFFFF;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .detailbuyprice {
    font-size: 23px;
    color: #FF0000;
    font-weight: 600;
  }

  .detailbuybotton {
    width: 268px;
    height: 38px;
    background: #FD8C00;
    color: #FFFFFF;
    border-radius: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 19px;
    font-weight: 600;
  }

  .detailnone {
    width: 100%;
    height: 100px;
  }

  .tabvaluebox {
    /* margin-bottom: 10px; */
    border: none;
  }

  /* 评价 */
  .pingjiatop {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .pingjianame {
    font-size: 15px;
  }

  .pingjiamorebox {
    display: flex;
    align-items: center;
  }

  .pingjiamore {
    font-size: 13px;
    margin-right: 3px;
  }

  .pingjiaicon {
    width: 15px;
    height: 15px;
  }

  .pingjiabox {
    width: 100%;
    margin-bottom: 16px;
  }

  .pingjiadetailtop {
    width: 100%;
    display: flex;

    justify-content: space-between;
    margin-bottom: 8px;
  }

  .pingjiadetailleft {
    display: flex;
    align-items: center;
  }

  .pingjiaimg {
    width: 38px;
    height: 38px;
    border-radius: 19px;
    margin-right: 13px;
  }

  .pingjiatel {
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 6px;
  }

  .pingjiaxingbox {
    display: flex;
    align-items: center;
  }

  .pingjiatime {
    font-size: 13px;
    color: #666666;
  }

  .labellist {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }

  .labelbox {
    width: 69px;
    height: 23px;
    background: #D9F0FF;
    border-radius: 4px;
    font-size: 13px;
    color:#FD8C00;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px;
  }

  .pingjiamessage {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 6px;
  }

  .pingjiaservebox {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .servenamepingjia {
    width: 69px;
    height: 23px;
    background: #F8F8FA;
    border-radius: 10px;
    //font-size: #8484A0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .evaStar {
    float: left;
    padding-top: .34rem;
  }

  .star {
    font-size: 0;
  }

  .star-item {
    display: inline-block;
    background-repeat: no-repeat;
    width: .6rem;
    height: .6rem;
    margin-left: .27rem;
    background-size: 100%;
  }

  .star-item.on {
    background-image: url(../../../static/xingpingjia.png);
  }

  .star-item.half {
    background-image: url(../../../static/xingpingjia.png);
  }

  .star-item.off {
    background-image: url(../../../static/xingnone.png);
  }

  .van-tabs__line {
    background-color: #FD8C00;
    width: 23px !important;
  }

  .detailbuybottonbox {
    display: flex;
    align-items: center;
  }

  .detailbuybotton1 {
    width: 115px;
    height: 38px;
    background: #7A7AAA;
    border-radius: 19px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #FFFFFF;
  }

  .detailbuybotton2 {
    width: 115px;
    height: 38px;
    background: #FD8C00;
    border-radius: 19px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/offline/serverDetail.vue